// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__uAf-y","icon":"styles_icon__q2Bu6","title":"styles_title__LlWDl","message":"styles_message__L4WJz"};